export default __webpack_public_path__ + "static/Graphik-MediumItalic-Web-584fe9012ad9cd803ec5de1f9f3f400e.svg";